import axios from "../utils/axios.wrapper";

const normalizeListResponse = (data) => ({
  items: Array.isArray(data?.items)
    ? data.items
    : Array.isArray(data?.Items)
    ? data.Items
    : Array.isArray(data)
    ? data
    : [],
  totalCount:
    data?.totalCount ??
    data?.TotalCount ??
    (Array.isArray(data?.items) ? data.items.length : 0) ??
    (Array.isArray(data?.Items) ? data.Items.length : 0),
});

export const getPosList = async () => {
  const response = await axios.get("/pos/active");
  return normalizeListResponse(response.data);
};
export const getPosByDateRange = async (filter) => {
  const response = await axios.post(
    "/pos/by-date-range",
    filter
  );

  return normalizeListResponse(response.data);
};

export const getPosById = async (id) => {
  const response = await axios.get(`/pos/${id}`);
  return response.data;
};

export const createPos = async (pos) => {
  const response = await axios.post("/pos/create", pos);
  return response.data;
};

export const updatePos = async (id, pos) => {
  const response = await axios.put(`/pos/${id}`, pos);
  return response.data;
};

export const deletePos = async (id) => {
  await axios.delete(`/pos/${id}`);
  return id;
};

export const closePos = async (id) => {
  const response = await axios.post(`/pos/close/${id}`);
  return response.data;
};

export const posService = {
  getPosList,
  getPosByDateRange,
  getPosById,
  createPos,
  updatePos,
  deletePos,
  closePos,
};